<template>
    <div class="aside" style="width: 128px;">

            <!--<div class="logo" style="height:60px;background:#002140;font-size:0;">-->
                <!--<img src="" alt=""><span class="cai">caimaomao</span>-->
            <!--</div>-->
            <el-menu
                    class="el-menu-vertical-demo"
                    :collapse="isCollapse"
                    background-color="#242f42"
                    text-color="#fff"
                    active-text-color="#ffd04b"
                    router
            >
                <template v-for="item in items">
                    <template v-if="item.subs">
                        <el-submenu :index="item.index" :key="item.index">
                            <template slot="title">
                                <i :class="item.icon"></i><span slot="title">{{ item.title }}</span>
                            </template>
                            <template v-for="subItem in item.subs">
                                <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index">
                                    <template slot="title">
                                        <i :class="subItem.icon"></i><span slot="title">{{ subItem.title }}</span>
                                        {{ subItem.title }}
                                    </template>
                                    <!--三级菜单-->
                                    <el-menu-item v-for="(threeItem,i) in subItem.subs" :key="i" :index="threeItem.index">
                                        {{ threeItem.title }}
                                    </el-menu-item>
                                </el-submenu>
                                <el-menu-item v-else :index="subItem.index" :key="subItem.index">
                                    {{ subItem.title }}
                                </el-menu-item>
                            </template>
                        </el-submenu>
                    </template>
                    <template v-else>
                        <!--style="rgb(255, 208, 75)"-->
                        <el-menu-item v-if="item.index" :index="item.index" :key="item.index"  v-bind:class="path === item.index ? 'typeselect' : ''"
                                      v-bind:style="{'color':path === item.index ? 'rgb(255, 208, 75)':'rgb(255, 255, 255)'}" style="padding-left: 10px;" >
                            <i :class="item.icon"></i>
                            <span slot="title">{{ item.title }}
                                <span style="margin-left: 10px">{{item.numberData}}</span>
                            </span>
                        </el-menu-item>
                    </template>
                </template>
            </el-menu>
        </div>
</template>
<script>
    export default {
        name:'Aside',
        props:{
            isCollapse:{
                type:Boolean,
                default:false
            }
        },
        data () {
            return {
                // isCollapse: false
                items: [
                    {
                        // icon: 'el-icon-star-on',
                        index: '/newlyAdded',
                        title: '数据统计',
                    },
                    {
                        // icon: 'el-icon-star-on',
                        index: '/sourceOfCase',
                        title: '案源管理',
                        numberData : '',
                    },
                    {
                        // icon: 'el-icon-star-on',
                        index: '/publicWelfare',
                        title: '公益管理',
                        numberData : '',
                    },
                    {
                        // icon: 'el-icon-star-on',
                        // index: '/recruit',
                        index: '',
                        title: '招聘管理',
                        numberData : '',
                    },
                    {
                        // icon: 'el-icon-star-on',
                        index: '',
                        // index: '/jobWanted',
                        title: '求职管理',
                    },
                    {
                        // icon: 'el-icon-star-on',
                        // index: '/train',
                        index: '',
                        title: '培训管理',
                        numberData : '',
                    }
                    // {
                    //     icon: 'el-icon-tickets',
                    //     index: '3',
                    //     title: '系统设置',
                    //     subs: [
                    //         {
                    //             icon: 'el-icon-tickets',
                    //             index: 'role',
                    //             title: '角色管理'
                    //         },
                    //         {
                    //             index: 'user',
                    //             title: '用户管理'
                    //         },
                    //         {
                    //             index:'direction',
                    //             title:'字典管理'
                    //         },
                    //         {
                    //             index:'message',
                    //             title:'消息管理'
                    //         },
                    //         {
                    //             index:'app',
                    //             title:'App管理'
                    //         },
                    //         {
                    //             index:'loginlog',
                    //             title:'登录日志'
                    //         },
                    //         {
                    //             index:'managelog',
                    //             title:'操作日志'
                    //         },
                    //         {
                    //             index:'errlog',
                    //             title:'异常日志'
                    //         },
                    //         {
                    //             index:'druid',
                    //             title:'Druid监控'
                    //         }
                    //     ]
                    // },
                    // {
                    //     icon: 'el-icon-tickets',
                    //     index: '2',
                    //     title: '错误页',
                    //     subs: [
                    //         {
                    //             icon: 'el-icon-tickets',
                    //             index: 'err404',
                    //             title: '404'
                    //         },
                    //         {
                    //             icon: 'el-icon-tickets',
                    //             index: 'err403',
                    //             title: '403'
                    //         },
                    //         {
                    //             icon: 'el-icon-tickets',
                    //             index: 'err500',
                    //             title: '500'
                    //         }
                    //     ]
                    // }
                ],
                numberData : [],
                path : '',
            }
        },
        computed :{
            onRoutes(){
                return this.$route.path.replace('/','');
            }
        },
        mounted () {
            var _this = this
            _this.path = this.$route.path;
            _this.send({
                server : 'ai',
                url : '/crowAidTotal',
                success: function (res) {
                    _this.items[1].numberData = res.data.caseCount +'件'
                    _this.items[2].numberData = res.data.crowdAidCount +'件'
                    _this.items[3].numberData = res.data.jobCount +'条'
                    _this.items[4].numberData = res.data.jobEducationCount +'条'
                    _this.items[5].numberData = res.data.trainCount +'条'
                }
            })
        },
        watch:{
            $route(to,from){
                this.path = to.path
            }
        }
    }
</script>
<style>
    .header{
        flex:0 0 60px;
        background:#fff;
        line-height:60px;
        box-shadow:2px 0 3px #ccc;
    }
    .content-wrap{
        flex:1;
        display:flex;
        flex-direction: column;
    }
    .typeselect{color:rgb(255, 208, 75)}
</style>
